import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubTgtLangSelect]'})
export class TargetLanguageSelectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
